import React from "react";
import PropTypes from "prop-types";

import {ResolutionLink} from "./ResolutionLink";


ResolutionList.propTypes = {
  resolutionLinks: PropTypes.array,
}

export function ResolutionList(props) {
  return (
    <div className="support-form-resolution-list">
      {props.resolutionLinks.map((resolutionLink, index) => (
        <ResolutionLink key={index} url={resolutionLink.url} name={resolutionLink.name}/>
      ))}
    </div>
  );
}
